module.exports = __webpack_public_path__ + "img/Pre-registration.1c6dff18.png";